export default __webpack_public_path__ + "static/media/reddit1.492f08e3.svg";